<div class="flex items-center justify-center p-6">
  <mat-card class="w-full max-w-[420px] text-center">
    <mat-card-content class="flex flex-col items-center px-8 py-10">

      <mat-icon class="text-5xl mb-4 text-primary" fontSet="mdi" fontIcon="mdi-shield-lock-outline"></mat-icon>

      <h1 class="text-2xl font-semibold m-0 mb-3">Vérifier votre compte</h1>

      <p class="text-sm text-on-surface-variant m-0 mb-8 leading-relaxed">
        Veuillez saisir le code à 6 chiffres envoyé par SMS/Email
      </p>

      <div class="flex justify-center gap-3 mb-8" [formGroup]="otpForm">
        @for (control of otpControls.controls; track $index) {
          <input type="text" class="otp-input" maxlength="1" pattern="[0-9]" inputmode="numeric"
            autocomplete="one-time-code" [formControl]="getControl($index)"
            (input)="handleInput($event, $index)"
            (keydown)="handleKeyDown($event, $index)" #otpInput />
        }
      </div>

      <p class="text-sm m-0">
        <span class="text-on-surface-variant">Vous n'avez pas reçu de code ?</span>
        <a href="#" class="ml-1 font-medium text-primary no-underline hover:underline" (click)="onResend($event)">
          Renvoyer
        </a>
      </p>

      @if (verificationStatus) {
        @if (verificationStatus.type === 'success') {
          <div class="mt-6 flex items-center gap-2 rounded-xl px-4 py-3 text-sm
                      bg-green-50 text-green-800 border border-green-200">
            <mat-icon class="text-green-600 !text-xl" fontSet="mdi" fontIcon="mdi-check-circle-outline"></mat-icon>
            {{ verificationStatus.message }}
          </div>
        } @else {
          <div class="mt-6 flex items-center gap-2 rounded-xl px-4 py-3 text-sm
                      bg-red-50 text-red-800 border border-red-200">
            <mat-icon class="text-red-600 !text-xl" fontSet="mdi" fontIcon="mdi-alert-circle-outline"></mat-icon>
            {{ verificationStatus.message }}
          </div>
        }
      }

    </mat-card-content>
  </mat-card>
</div>
